// 即时消息顶部图标组件


import SHMsgIcon from './src/icon.vue';
SHMsgIcon.install = function(Vue) {
    Vue.component('sh-msg-icon', SHMsgIcon);
  };
  export default SHMsgIcon;


// WEBPACK FOOTER //
// ./src/components/base/view/msg/cmps/icon/index.js